import { render, staticRenderFns } from "./running.vue?vue&type=template&id=056d7ad4"
import script from "./running.vue?vue&type=script&lang=js"
export * from "./running.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports